<template>
    <div
        class="container-fluid entry-header content-blocks content-blocks-centered journal-entry-header d-flex flex-column">
        <div class="entry-header-surface">
            <div class="text-heading-md animation-heading journal-entry-header__heading">
                <h1 class="entry-title" v-html="entry.title"></h1>
                <div v-if="entry.credits || entry.postDate"
                    class="block entry-credits block-text-standard container-fluid">
                    <div class="row content-block-row">
                        <div class="col">
                            <div v-if="entry.credits" class="credits" v-html="entry.credits"></div>
                            <div v-if="entry.postDate" class="entry-date" v-html="entry.postDate"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JournalEntryHeader',
    components: {},
    props: {
        entry: {
            default: null,
        },
    },
};
</script>
